module.exports = __webpack_public_path__ + "img/program_logo.185c13ae.png";